'use client'

import Image from 'next/image'

import { Button, ButtonSize, ButtonVariant, ButtonWeight, Icon } from '@graftcode/design-system'

import errorStateImage from './error-state.png'

import styles from './ErrorState.module.scss'

interface ErrorStateProps {
  onRetry?: () => void
}

export function ErrorState({ onRetry }: ErrorStateProps) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <Image src={errorStateImage} alt="Error state icon" className={styles.errorIcon} width={190} height={160} />
        </div>
        <h2 className={styles.title}>Unable to load data</h2>
        <p className={styles.message}>Could not fetch libraries from the gateway.</p>
        {onRetry && (
          <div className={styles.buttonContainer}>
            <Button
              variant={ButtonVariant.Secondary}
              size={ButtonSize.L}
              weight={ButtonWeight.Semibold}
              text="Retry"
              icon={Icon.ArrowClockwiseRegular}
              iconPlacement="left"
              onClick={onRetry}
            />
          </div>
        )}
      </div>
    </div>
  )
}
